export default __webpack_public_path__ + "static/media/blueprint_logo_round.42bd4578.svg";